var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticClass:"font--button rounded-pill",on:{"click":_vm.handleClick}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [(_vm.nativeShareSupported)?[_vm._v("\n      "+_vm._s(_vm.nativeShareLabel)+"\n    ")]:[_vm._v("\n      "+_vm._s(_vm.shareLabel)+"\n    ")]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }